module.exports = __webpack_public_path__ + "img/28.a9e43cc2.png";